<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-form id="form">
      <v-card>
        <template v-slot:heading>
          <div class="display-2 font-weight-light">
            {{
              id
                ? $i18n.t("Edit Tax Slab - ") + taxslab.name
                : $i18n.t("Create Tax Slab")
            }}
          </div>
        </template>
        <v-card-text>
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field v-model="taxslab.name" :label="$i18n.t('Name')" />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="taxslab.amount"
                  :label="$i18n.t('Amount')"
                  type="number"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2">
                <toggle-button
                  v-model="taxslab.isAbs"
                  :labels="{ checked: '/-', unchecked: '%' }"
                  lg
                  :height="30"
                  :width="70"
                  :font-size="20"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="taxslab.isDefault"
                  :label="$i18n.t('Default')"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="taxslab.forSEZ"
                  :label="$i18n.t('For SEZ')"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="taxslab.desc"
                  :label="$i18n.t('Description')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-card>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <v-col cols="12" md="4" class="mx-3">
                        <h3>{{ $i18n.t("Tax Items") }}</h3>
                      </v-col>
                      <v-spacer />
                      <v-col clos="12" md="6">
                        <v-btn
                          @click="taxslab.taxItems = newItem(taxslab.taxItems)"
                          small
                          style="width: 60px; float: right"
                          color="light-blue"
                          text
                        >
                          <v-icon>mdi-plus</v-icon>
                          <h3>{{ $i18n.t("Add") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-simple-table dense style="padding: 10px">
                    <tbody>
                      <tr
                        v-for="(item, index) in taxslab.taxItems"
                        :key="'item' + index"
                      >
                        <td>
                          <v-text-field
                            v-model="item.title"
                            :label="$i18n.t('Tax Title')"
                          />
                        </td>
                        <td>
                          <v-row>
                            <v-text-field
                              v-model="item.amount"
                              :label="$i18n.t('Amount')"
                              type="number"
                            />
                            <toggle-button
                              v-model="item.isAbs"
                              :labels="{ checked: '/-', unchecked: '%' }"
                              lg
                              :height="30"
                              :width="70"
                              :font-size="20"
                            />
                          </v-row>
                        </td>
                        <td>
                          <v-text-field
                            v-model="item.desc"
                            :label="$i18n.t('Descriptin')"
                          />
                        </td>
                        <td>
                          <v-btn
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            @click="remove(taxslab.taxItems, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn
                  color="success"
                  class="mr-0"
                  @click="save()"
                  :loading="loading"
                >
                  <h3>{{ $i18n.t("Save") }}</h3>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component } from "vue-property-decorator";

@Component({
  props: {
    label: {
      default: "Create Tax Slab",
    },
    taxSlab_id: {
      default: null,
    },
    singlePage: {
      default: false,
    },
  },
})
export default class TaxSlabEdit extends Vue {
  taxslabPOSO = { taxItems: [] };
  taxslab = this.taxslabPOSO;
  id = null;

  get loading() {
    return common.loading;
  }

  reload() {
    this.$emit("reload");
  }
  select(data) {
    this.$emit("select", data);
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/taxslab/save", this.taxslab);
      common.setLoading(false);
      common.showMessage(`Tax Slab ${response.name} Saved Successfully`);
      if (this.singlePage) {
        this.$emit("select", {
          name: response.name,
          _id: response._id,
        });
        this.taxslab = this.taxslabPOSO;
      } else if (!this.isTaxSlabAdd) {
        this.$emit("select", {
          name: response.name,
          _id: response._id,
        });
        this.taxslab = this.taxslabPOSO;
      } else {
        if (!this.id) this.$router.push("/taxslab/" + response._id);
        this.get(response._id);
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/taxslab/" + id + "/detail");
      if (!response.taxItems) response.taxItems = [];
      this.taxslab = response;
      this.id = this.taxslab._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.taxSlab_id) {
      await this.get(this.taxSlab_id);
    } else if (this.isTaxSlabAdd && this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
